import React from 'react';

const SchemaCard = ({ outputSchema }) => {
  return (
    <section className="prompt-template-detail__card prompt-template-detail__card--schema">
      <header className="prompt-template-detail__card-header">
        <div>
          <h2 className="prompt-template-detail__card-title">Output Schema</h2>
          <p className="prompt-template-detail__card-subtitle">
            Define the expected JSON structure for responses.
          </p>
        </div>
      </header>

      {outputSchema ? (
        <pre className="prompt-template-detail__content-block">
          {outputSchema}
        </pre>
      ) : (
        <p className="prompt-template-detail__placeholder">
          No output schema provided.
        </p>
      )}
    </section>
  );
};

export default SchemaCard;

